import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './index.css';
import Login from './components/Auth/Login';
import DashboardLayout from './components/Dashboard/DashboardLayout';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

// Import all page components
import QuickStats from './components/Dashboard/QuickStats';
import AartiList from './components/Aarti/AartiList';
import PathhManagement from './components/Pathh/PathhManagement';
import ChalisaList from './components/Chalisa/ChalisaList';
import BhajanManagement from './components/Bhajan/BhajanManagement';
import UserList from './components/User/UserList';
import PanditManagement from './components/Pandit/PanditManagement';
import PanditApprovalManagement from './components/Pandit/PanditApprovalManagement';
import HoroscopeList from './components/Horoscope/HoroscopeList';
import MantrasList from './components/Mantras/MantrasList';
import PanchangList from './components/Panchang/PanchangList';
import PujaManagement from './components/Puja/PujaManagement';
import Notifications from './components/Notifications/Notifications';
import ReferralManagement from './components/Referral/ReferralManagement';
import TransactionList from './components/Transactions/TransactionList';
import BookingList from './components/Bookings/BookingList';

// Protected Route wrapper
const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const token = localStorage.getItem('adminToken');
    const authStatus = localStorage.getItem('isAuthenticated');

    if (token && authStatus === 'true') {
      setIsAuthenticated(true);
    }

    setIsLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('isAuthenticated');
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #FF6B35, #F7931E)',
        color: 'white',
        fontSize: '1.5rem'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <ErrorBoundary showDetails={true}>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Login Route */}
            <Route
              path="/login"
              element={
                isAuthenticated ?
                  <Navigate to="/admin/dashboard" replace /> :
                  <Login onLogin={handleLogin} />
              }
            />

            {/* Protected Admin Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <DashboardLayout onLogout={handleLogout} />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<QuickStats />} />
              <Route path="aarti" element={<AartiList />} />
              <Route path="pathh" element={<PathhManagement />} />
              <Route path="chalisa" element={<ChalisaList />} />
              <Route path="bhajan" element={<BhajanManagement />} />
              <Route path="pujas" element={<PujaManagement />} />
              <Route path="users" element={<UserList />} />
              <Route path="pandits" element={<PanditManagement />} />
              <Route path="pandit-approvals" element={<PanditApprovalManagement />} />
              <Route path="horoscope" element={<HoroscopeList />} />
              <Route path="mantras" element={<MantrasList />} />
              <Route path="panchang" element={<PanchangList />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="referrals" element={<ReferralManagement />} />
              <Route path="transactions" element={<TransactionList />} />
              <Route path="bookings" element={<BookingList />} />
            </Route>

            {/* Redirect root to admin or login */}
            <Route
              path="/"
              element={<Navigate to={isAuthenticated ? "/admin/dashboard" : "/login"} replace />}
            />

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;